
import { decToHex, formatDate, GB18030StringZh, accDiv, accMul, accSub, accAdd, formatDegree, formatDegree2, formatNumber } from './global.js';

class tdwtClass {
    constructor(props) {
        // 入站确认申请
        this.inbound = { 1: "不需确认", 2: "需确认" };
        // 编码类别
        this.codingType = { 1: "汉字", 2: "代码", 3: "混编", 4: "压缩汉字", 5: "压缩代码" };
        // 报文通信频度
        // this.frequentness = { 0: "单次" } 4.6短信传输协议:*终端到用户带位置:0x954.5微信传输协议:终端到用户:0x96
        this.agreementType = {
            13: "APP报警到平台-携带位置",
            14: "APP报平安到平台-携带位置",
            15: "APP位置到平台",
            16: "APP到平台带速度和方向",
            90: "文本传输协议:终端到终端",
            91: "文本传输协议:*终端到终端带位置",
            92: "文本传输协议:终端到平台",
            93: "文本传输协议:*终端到平台带位置",
            94: "短信传输协议:终端到用户",
            95: "短信传输协议:*终端到用户带位置",
            96: "微信传输协议:终端到用户",
            97: "微信传输协议:*终端到用户带位置",
            'A0': "文本传输协议:平台到终端",
            'A1': "文本传输协议:*平台到终端带位置",
            'F2': "落水报警到平台",
            'F4': "开/关机到平台",
            '23': "报告指令",
            '01': "报平安",
            'E1': "报平安",
            'E4': "极限追踪",
            '10': "极限追踪",
            'D0': "传感器数据协议:多条数据的封装协议",
            'D1': "传感器数据协议:单条数据协议",
            '00': "自动位置上报",
            'A4': "自动位置上报",
            'E0': "天通ID查询/响应协议",
        }
        // 状态
        this.statusType = [
            { content: '其他', id: '00' },
            { content: '迷路', id: '01' },
            { content: '山洪', id: '02' },
            { content: '滑坠', id: '03' },
            { content: '线路受损', id: '04' },
            { content: '落石', id: '05' },
            { content: '交通事故', id: '06' },
            { content: '失温', id: '07' },
            { content: '中暑', id: '08' },
            { content: '高山病', id: '08' },
            { content: '心脏病', id: '0A' },
            { content: '中毒', id: '0B' },
        ]
        this.bodyType = [
            { content: '良好', id: '00' },
            { content: '无法行走', id: '01' },
            { content: '失血过多', id: '02' },
            { content: '饥渴饥饿', id: '03' },
            { content: '皮外伤', id: '04' },
        ]
        // 传感器类型
        this.sensorType = [
            { content: '相对湿度', unit: '', id: '01' },
            { content: '露点温度', unit: '', id: '02' },
            { content: '环境温度', unit: '', id: '03' },
            { content: '光电辐射(光照强度)', unit: '', id: '04' },
            { content: '风向', unit: '', id: '05' },
            { content: '风速', unit: '', id: '06' },
            { content: '蒸发量', unit: 'g', id: '07' },
            { content: '雨量', unit: 'mm', id: '08' },
            { content: '电池电量', unit: '%', id: '09' },
            { content: '光伏电压', unit: 'V', id: '0A' },
            { content: '电池电压', unit: 'V', id: '0B' },
            { content: '充电电流', unit: 'A', id: '0C' },
            { content: '输出电流', unit: 'A', id: '0D' },
            { content: '设备内部温度', unit: '℃', id: '0E' },
            { content: 'PM2.5', unit: '', id: '0F' },
            { content: 'PM10', unit: '', id: '10' },
            { content: '二氧化碳', unit: '', id: '11' },
            { content: '水位', unit: '', id: '12' },
            { content: '水速', unit: '', id: '13' },
            { content: '内部温度', unit: '', id: '14' },
            { content: '蒸发量器剩余水量', unit: '', id: '15' },
            { content: '北斗信号', unit: '', id: '65' },
        ]
    }
    commandTdwt(charCode) {
        const instructArr = charCode.split(",");
        const code1 = instructArr[1];
        const code2 = instructArr[2];
        const code3 = instructArr[3];
        const code4 = instructArr[4];
        const code5 = instructArr[5];
        const code6 = instructArr[6];
        // let htmlReturn = `<div class="mb_10">输出：${charCode}</div> `;
        let htmlReturn = ``;
        htmlReturn += `<div>收信方ID：${code1}</div>`;
        htmlReturn += `<div>频点：LF${code2}</div>`;
        htmlReturn += `<div>入站确认：${this.inbound[code3]}</div>`;
        htmlReturn += `<div>编码类别：${this.codingType[code4]}</div>`;
        htmlReturn += `<div>通信数据：</div>`;
        htmlReturn += this.communicationData(code5, code4);
        const frequentnessArr = code6.split("*");
        htmlReturn += `<div >频度：${frequentnessArr[0] == 0 ? '单次' : `${frequentnessArr[0]}秒`}</div>`;
        return htmlReturn;
    }

    /**
    *@description: 
    *@param {*} charData 通信数据
    *@param {*} codingType  编码类别
    *@Date :  2024-02-27 13:46:53
    */
    communicationData(datas, codingType) {
        const charData = datas.toUpperCase();
        let htmlCommunication = ``;
        if (codingType == 1 || codingType == 4) {
            htmlCommunication = `<div class="ml_20 mb_10">${charData}</div>`;
            return htmlCommunication;
        }
        if(codingType == 3){
            const set = charData.substr(2);//  说明 信息
            htmlCommunication += `<div class="ml_20 mb_10">${GB18030StringZh(set)}</div>`;
            return htmlCommunication;
        }
        const agreementCode = charData.substr(0, 2);
        switch (agreementCode) {
            case "13":
                htmlCommunication = this.agreementLocSos(charData);
                break;
            case "14":
                htmlCommunication = this.agreementLocOk(charData);
                break;
            case "15":
                htmlCommunication = this.agreementLocApp(charData);
                break;
            case "16":
                htmlCommunication = this.agreementLocApp16(charData);
                break;
            case "91":
            case "93":
            case "97":
            case "A1":
                htmlCommunication = this.agreementLoc(charData);
                break;
            case "90":
            case "92":
            case "94":
            case "96":
            case "A0":
                htmlCommunication = this.agreementLocNo(charData);
                break;
            case "F2":
                htmlCommunication = this.agreementLocFall(charData);
                break;
            case "F4":
                htmlCommunication = this.agreementLocOnOff(charData);
                break;
            case "23":
                htmlCommunication = this.agreement23(charData);
                break;
            case "10":
                htmlCommunication = this.agreementE4(charData);
                break;
            case "D0":
                htmlCommunication = this.agreementCGQ(charData);
                break;
            case "D1":
                htmlCommunication = this.agreementD1(charData);
                break;
            case "00":
                htmlCommunication = this.agreement00(charData);
                break;
            case "01":
                htmlCommunication = this.agreementHardware01(charData);
                break;
            case "E0":
                htmlCommunication = this.agreementE0(charData);
                break;
            default:
                htmlCommunication = `<div class="ml_20 mb_10">${charData}</div>`;
                // alert("数据错误或未获取该协议");
                break;
        }
        return htmlCommunication;
    }
    setPosition(setData, speedIf) {
        const Longitude = setData.substr(0, 8);// Position 长度(byte) 4 用户位置的经度，没有位置则为：0xFFFFFFFF
        const Latitude = setData.substr(8, 8);// Position 长度(byte) 4 用户位置的纬度，没有位置则为：0xFFFFFFFF
        const Height = setData.substr(16, 4);// Position 长度(byte) 2 用户的海拔高度，没有位置则为：0xFFFF，单位：米
        const Speed = speedIf ? setData.substr(20, 4) : '';// Position 长度(byte) 2 用户速度，没有速度则为：0xFFFF，单位：km/h，1位小数点。
        const Direction = speedIf ? setData.substr(24, 4) : '';// Position 长度(byte) 2 用户方向，没有方向则为：0xFFFF  

        const Height1 = setData.substr(16, 2);// Position 长度(byte) 1 ’00’表示高度为正，01表示高度为负
        const Height2 = setData.substr(18, 2);// Position 长度(byte) 1 表示高度的绝对值
        let htmlAgreement = `<div>位置：${Longitude == 'FFFFFFFF' ? '无定位' :
            `<div class="ml_20">
        经度：${formatDegree(accDiv(decToHex(Longitude, 10), 1000000), 'longitude', 2)}  
        纬度：${formatDegree(accDiv(decToHex(Latitude, 10), 1000000), 'latitude', 2)}  
        高度：${Height == 'FFFF' ? '-' : `${decToHex(Height1, 10) == 1 ? '-' : ''}${decToHex(Height2, 10)}`}
        ${speedIf ? `速度：${Speed == 'FFFF' ? '' : accDiv(decToHex(Speed, 10), 10)}` : ``}
        ${speedIf ? `方向：${Direction == 'FFFF' ? '' : decToHex(Direction, 10)}` : ``}
        </div>`}
        </div>`;
        return htmlAgreement
    }
    /**
    *@description: 处理协议 91 93,97  携带位置
    *@param {*}   格式: 97   0442902AAB 65E6CE8E  01 61 51 BA 06 C3 E0 40 00 17 9439FD36953081349439FC389439FD339530CF369439FD33
    */
    agreementLoc(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 消息类型
        const agreement1 = charData.substr(2, 10);// 长度(byte) 5  说明 接收者手机号
        const agreement2 = charData.substr(12, 8);// 长度(byte) 4  说明 发送时间戳，单位是:s
        const agreement3 = charData.substr(20, 20);// 长度(byte) 10  说明 用户位置，参考：Position
        const agreement4 = charData.substr(40);//  说明 信息

        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：${this.agreementType[agreement0]}</div>`;
        htmlAgreement += `<div>接收者：${agreement1 == '0110110110' ? '平台' : decToHex(agreement1, 10)}</div>`;
        htmlAgreement += `<div>发送时间：${formatDate(accMul(decToHex(agreement2, 10), 1000))}</div>`;
        htmlAgreement += this.setPosition(agreement3);
        htmlAgreement += `<div>信息：${GB18030StringZh(agreement4)}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description: 处理协议  90,92,96
    *@param {*}   格式: 90045F2DA17E65DEDDC4CED2D2D1B0B2C8ABB5BDB4EF
    */
    agreementLocNo(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 消息类型
        const agreement1 = charData.substr(2, 10);// 长度(byte) 5  说明 接收者手机号
        const agreement2 = charData.substr(12, 8);// 长度(byte) 4  说明 发送时间戳，单位是:s
        const agreement4 = charData.substr(20);// 说明 信息

        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：${this.agreementType[agreement0]}</div>`;
        htmlAgreement += `<div>接收者：${agreement1 == '0110110110' ? '平台' : decToHex(agreement1, 10)}</div>`;
        htmlAgreement += `<div>发送时间：${formatDate(accMul(decToHex(agreement2, 10), 1000))}</div>`;
        htmlAgreement += `<div>信息：${GB18030StringZh(agreement4)}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description: 处理协议  13
    */
    agreementLocSos(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 消息类型
        const agreement1 = charData.substr(2, 2);// 长度(byte) 1  说明 0: 表示内容为文本内容。1：表示内容为语音。
        const agreement2 = charData.substr(4, 10);// 长度(byte) 5  说明 紧急联系人手机号，如果没有就填写：0xFFFFFFFFFF
        const agreement3 = charData.substr(14, 20);// 长度(byte) 10  说明 用户位置，参考：Position
        const agreement4 = charData.substr(34, 2);// 长度(byte) 1  说明 当前状态，状态码在列表中给出
        const agreement5 = charData.substr(36, 2);// 长度(byte) 1  说明 身体情况，状态码在列表中给出
        const agreement6 = charData.substr(38, 2);// 长度(byte) 1  说明 同行人数
        const agreement7 = charData.substr(40);//   说明 信息

        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：${this.agreementType[agreement0]}</div>`;
        htmlAgreement += `<div>类型：${agreement1 == '00' ? '文本内容' : '语音'}</div>`;
        htmlAgreement += `<div>紧急联系人手机号：${agreement2 == 'FFFFFFFFFF' ? '无' : decToHex(agreement2, 10)}</div>`;
        htmlAgreement += this.setPosition(agreement3);
        htmlAgreement += `<div>当前状态：${this.statusType.find(f => f.id == agreement4)?.content || '-'}</div>`;
        htmlAgreement += `<div>身体情况：${this.bodyType.find(f => f.id == agreement5)?.content || '-'}</div>`;
        htmlAgreement += `<div>同行人数：${decToHex(agreement6, 10) <= 10 ? '1-10人' : `${decToHex(agreement6, 10)}人`}</div>`;
        htmlAgreement += `<div>信息：${GB18030StringZh(agreement7)}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description: 处理协议  14
    */
    agreementLocOk(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 消息类型
        const agreement1 = charData.substr(2, 2);// 长度(byte) 1  说明 0: 表示内容为文本内容。1：表示内容为语音。
        const agreement2 = charData.substr(4, 2);// 长度(byte) 1  说明 预留字段
        const agreement3 = charData.substr(6, 10);// 长度(byte) 5  说明 紧急联系人手机号，如果没有就填写：0xFFFFFFFFFF
        const agreement4 = charData.substr(16, 20);// 长度(byte) 10  说明 用户位置，参考：Position
        const agreement5 = charData.substr(36);//   说明 信息

        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：${this.agreementType[agreement0]}</div>`;
        htmlAgreement += `<div>类型：${agreement1 == '00' ? '文本内容' : '语音'}</div>`;
        htmlAgreement += `<div>紧急联系人手机号：${agreement3 == 'FFFFFFFFFF' ? '无' : decToHex(agreement3, 10)}</div>`;
        htmlAgreement += this.setPosition(agreement4);
        htmlAgreement += `<div>信息：${GB18030StringZh(agreement5)}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description: 处理协议  15
    *@param {*} 格式 15ffffff014003010161B84F06C393DFFFFF65DEDDC4CED2D2D1B0B2C8ABB5BDB4EF
    */
    agreementLocApp(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 消息类型
        const agreement1 = charData.substr(2, 5);// 长度(byte) 3  说明 保留字段
        const agreement2 = charData.substr(8, 2);// 长度(byte) 1  说明 版本号，单位 0.1;如 12，版本为 1.2每次更新至少一个小版本
        const agreement3 = charData.substr(10, 2);// 长度(byte) 1  说明 百分比电量
        const agreement4 = charData.substr(12, 2);// 长度(byte) 1  说明 轨迹编号。默认为0
        const agreement5 = charData.substr(14, 2);// 长度(byte) 1  说明 位置个数N，N∈[0,5]

        const locNumber = decToHex(agreement5, 10);
        const locNumberSubstrEnd = accMul(locNumber, 28); //位置个数N的结束位置  位置长度(byte) 10   时间戳长度(byte) 4    
        const agreement6 = charData.substr(locNumberSubstrEnd + 16);//   说明 信息

        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：${this.agreementType[agreement0]}</div>`;
        htmlAgreement += `<div>版本号：${decToHex(agreement2, 10)}</div>`;
        htmlAgreement += `<div>百分比电量：${decToHex(agreement3, 10)}</div>`;
        htmlAgreement += `<div>轨迹编号：${decToHex(agreement4, 10)}</div>`;
        htmlAgreement += `<div>位置个数：${locNumber}</div>`;

        for (let index = 0; index < locNumber; index++) {
            const element = 16 + accMul(index, 28);
            const locItem = charData.substr(element, 28);
            const Time = locItem.substr(20, 8);// Position 长度(byte) 4 时间戳
            htmlAgreement += `<div class="ml_20">第${index + 1}个位置：${this.setPosition(locItem)}<div>时间：${formatDate(accMul(decToHex(Time, 10), 1000))}</div></div>`;
        }
        htmlAgreement += `<div>信息：${charData.length > (locNumberSubstrEnd + 16) ? GB18030StringZh(agreement6) : '-'}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description: 处理协议  16
    *@param {*} 格式  16ffffff014003010161B84F06C393DFFFFF0100003065DEDDC4CED2D2D1B0B2C8ABB5BDB4EF
    */
    agreementLocApp16(charData) {
        console.log("charData==>", charData)
        console.log("charData==>", charData.length)
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 消息类型
        const agreement1 = charData.substr(2, 5);// 长度(byte) 3  说明 保留字段
        const agreement2 = charData.substr(8, 2);// 长度(byte) 1  说明 版本号，单位 0.1;如 12，版本为 1.2每次更新至少一个小版本
        const agreement3 = charData.substr(10, 2);// 长度(byte) 1  说明 百分比电量
        const agreement4 = charData.substr(12, 2);// 长度(byte) 1  说明 轨迹编号。默认为0
        const agreement5 = charData.substr(14, 2);// 长度(byte) 1  说明 位置个数N，N∈[0,5]

        const locNumber = decToHex(agreement5, 10);

        const locNumberSubstrEnd = accMul(locNumber, 36); //位置个数N的结束位置 PositionV2  位置长度(byte) 14   时间戳长度(byte) 4    （14+4）*2 = 36 
        const agreement6 = charData.substr(locNumberSubstrEnd + 16);//   说明 信息

        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：${this.agreementType[agreement0]}</div>`;
        htmlAgreement += `<div>版本号：${decToHex(agreement2, 10)}</div>`;
        htmlAgreement += `<div>百分比电量：${decToHex(agreement3, 10)}</div>`;
        htmlAgreement += `<div>轨迹编号：${decToHex(agreement4, 10)}</div>`;
        htmlAgreement += `<div>位置个数：${locNumber}</div>`;

        for (let index = 0; index < locNumber; index++) {
            const element = 16 + accMul(index, 36);
            const locItem = charData.substr(element, 36);
            const Time = locItem.substr(28, 8);// Position 长度(byte) 4 时间戳
            htmlAgreement += `<div class="ml_20">第${index + 1}个位置：${this.setPosition(locItem, true)}<div>时间：${formatDate(accMul(decToHex(Time, 10), 1000))}</div></div>`;
        }
        htmlAgreement += `<div>信息：${charData.length > (locNumberSubstrEnd + 16) ? GB18030StringZh(agreement6) : '-'}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description: 处理协议  F2
    */
    agreementLocFall(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 消息类型
        const agreement1 = charData.substr(2, 10);// 长度(byte) 5  说明 保留字段
        const agreement2 = charData.substr(12, 20);// 长度(byte) 10  说明 用户位置，参考：Position
        const agreement3 = charData.substr(32, 8);//  长度(byte) 4 时间戳
        const agreement4 = charData.substr(40, 4);//  长度(byte) 2 速度
        const agreement5 = charData.substr(44, 4);//  长度(byte) 2 方向
        const agreement6 = charData.substr(48, 8);//  长度(byte) 4 用户终端标识的唯一编码
        const agreement7 = charData.substr(56);// 聊天信息,GB18030编码

        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：${this.agreementType[agreement0]}</div>`;
        htmlAgreement += this.setPosition(agreement2);
        htmlAgreement += `<div>时间：${formatDate(accMul(decToHex(agreement3, 10), 1000))}</div>`;
        htmlAgreement += `<div>速度：${decToHex(agreement4, 10)}km/h</div>`;
        htmlAgreement += `<div>方向：${decToHex(agreement5, 10)}°</div>`;
        htmlAgreement += `<div>终端标识码：${decToHex(agreement6, 10)}</div>`;
        htmlAgreement += `<div>信息：${GB18030StringZh(agreement7)}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description: 处理协议  F4
    */
    agreementLocOnOff(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 消息类型
        const agreement1 = charData.substr(2, 2);// 长度(byte) 1  说明 开关机类型，0:关机，1:开机
        const agreement2 = charData.substr(4, 2);// 长度(byte) 1  说明 电量，范围∈[0，100]
        const agreement3 = charData.substr(6, 2);//  长度(byte) 1 说明 转为二进制。第1位为1表示带版本，第2位为1表示带位置
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：${this.agreementType[agreement0]}</div>`;
        htmlAgreement += `<div>开关机类型：${decToHex(agreement1, 10) == 1 ? '开机' : '关机'}</div>`;
        htmlAgreement += `<div>电量：${decToHex(agreement2, 10)}%</div>`;
        const w1 = agreement3.substr(0, 1);
        const w2 = agreement3.substr(1, 1);
        if (w1 == 1) {
            const agreement4 = charData.substr(8, 20);// 长度(byte) 10  说明 用固件版本号
            htmlAgreement += `<div>固件版本号：${decToHex(agreement4, 10)}</div>`;
        }
        if (w2 == 1) {
            const endNum = w1 == 1 ? 28 : 8;
            const agreement5 = charData.substr(endNum, 20);// 说明 用户位置，参考：Position
            htmlAgreement += this.setPosition(agreement5);
        }
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description: 处理协议  23
    *@param {*}   23  0000000000  01  12  2300000000000112
    */
    agreement23(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 消息类型  230000000000
        const agreement1 = charData.substr(2, 10);// 长度(byte) 5  说明 预留字段,0000000000
        const agreement2 = charData.substr(12, 2);// 长度(byte) 1  说明 报告类型：1、开机2、关机 3、定位超时 255、硬件异常
        const agreement3 = charData.substr(14, 2);//  长度(byte) 1 说明 电池百分比
        let baig = { 1: "开机", 2: "关机", 3: "定位超时", 255: "硬件异常" }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：${this.agreementType[agreement0]}</div>`;
        htmlAgreement += `<div>报告类型：${baig[decToHex(agreement2, 10)] || ''}</div>`;
        htmlAgreement += `<div>电量：${decToHex(agreement3, 10)}%</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description: 硬件协议  01 
    *@param {*} 
    */
    agreementHardware01(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 常量,01
        const agreement01 = charData.substr(2, 2);
        let htmlCommunication2 = ``;
        switch (agreement01) {
            case "EE":
                // alert("SOS类型判断错误，未获取该协议");
                htmlCommunication2 = this.agreementEESOS(charData);
                break;
            case "E1":
                htmlCommunication2 = this.agreementOK(charData);
                break;
            default:
                alert("数据错误或未获取该协议");
                break;
        }
        return htmlCommunication2;
    }
    /**
    *@description: 处理协议  01 EE
    *@param {*} 例子  01 EE 18030D081F24 45 711E0008 4E 17091202 0001 0000  13    
    *@param {*} 例子  01EE18030D081F2445711E00084E170912020001000013
    *@param {*} 例子  01 EE 65DEDDC4 711A2D02 17091B06 0101 0001  CED2D2D1B0B2C8ABB5BDB4EF
    *@param {*} 例子  01EE65DEDDC4711A2D0217091B0601010001CED2D2D1B0B2C8ABB5BDB4EF
    *@param {*} 例子  01EE000000CED2D2D1B0B2C8ABB5BDB4EF 01EE000000WEJQEIJOJIOFHASLIDJWIOQOEIQJIOWKLLSDOIAAWIJEQWEJOPJIOJLKLLKJ
    */
    agreementEESOS(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 常量,01
        const agreement1 = charData.substr(2, 2); // 长度(byte) 1  说明 常量，EE
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：二代盒子的扩展功能</div>`;
        htmlAgreement += `<div>指令类型：二代盒子的SOS功能</div>`;


        const cotitlesos = charData.substr(4, 6)// // 长度(byte) 3  ‘SOS’的ASCII码
        const cotitle = charData.substr(10)// 信息
        if (cotitlesos == '534F53' && GB18030StringZh(cotitle)) {
            htmlAgreement += `<div>信息：${GB18030StringZh(cotitle)}</div>`;
            htmlAgreement += `</div>`;
            return htmlAgreement;
        }


        const locItem = charData.substr(4, 12); // 长度(byte) 6  说明 时间
        const t1 = locItem.substr(0, 2);
        const t2 = locItem.substr(2, 2);
        const t3 = locItem.substr(4, 2);
        const t4 = locItem.substr(6, 2);
        const t5 = locItem.substr(8, 2);
        const t6 = locItem.substr(10, 2);
        const Time = `20${formatNumber(decToHex(t1, 10))}-${formatNumber(decToHex(t2, 10))}-${formatNumber(decToHex(t3, 10))}  ${formatNumber(decToHex(t4, 10))}:${formatNumber(decToHex(t5, 10))}:${formatNumber(decToHex(t6, 10))}`;
        const date = new Date(Time);
        if (charData.length == 58 && !isNaN(date.getTime())) {
            htmlAgreement += `<div>时间：${Time}</div>`;
            const lonlocItem = charData.substr(16, 10); // 长度(byte) 5  说明 经度
            const LongFx = lonlocItem.substr(0, 2);
            const Longitude = lonlocItem.substr(2, 8);
            const lon1 = decToHex(Longitude.substr(0, 2), 10);
            const lon2 = decToHex(Longitude.substr(2, 2), 10);
            const lon3 = decToHex(Longitude.substr(4, 2), 10);
            const lon4 = decToHex(Longitude.substr(6, 2), 10);
            const lon = accAdd(accAdd(lon1, accDiv(lon2, 60)), accDiv(`${lon3}.${formatNumber(lon4)}`, 3600));
            const latlocItem = charData.substr(26, 10);// 长度(byte) 5  说明 纬度
            const LatFx = latlocItem.substr(0, 2);
            const Latitude = latlocItem.substr(2, 8);
            const lat1 = decToHex(Latitude.substr(0, 2), 10);
            const lat2 = decToHex(Latitude.substr(2, 2), 10);
            const lat3 = decToHex(Latitude.substr(4, 2), 10);
            const lat4 = decToHex(Latitude.substr(6, 2), 10);
            const lat = accAdd(accAdd(lat1, accDiv(lat2, 60)), accDiv(`${lat3}.${formatNumber(lat4)}`, 3600));
            htmlAgreement += `<div>经度：${formatDegree2(lon, 2)} ${LongFx == '57' ? 'W' : 'E'}</div>`;
            htmlAgreement += `<div>纬度：${formatDegree2(lat, 2)} ${LatFx == '53' ? 'S' : 'N'}</div>`;
            const agreement5 = charData.substr(36, 4);// 长度(byte) 2 
            const Height1 = agreement5.substr(0, 2);
            const Height2 = agreement5.substr(2, 2);
            htmlAgreement += `<div>高度：${agreement5 == 'FFFF' ? '-' : `${decToHex(Height1, 10) == 1 ? '-' : ''}${decToHex(Height2, 10)}`}</div>`;
            const agreement6 = charData.substr(40, 4);// 长度(byte) 2 
            const agreement7 = charData.substr(44, 2);// 长度(byte) 1 
            htmlAgreement += `<div>电量：${decToHex(agreement7, 10)}%</div>`;
            const agreement8 = charData.substr(36, 4);// 长度(byte) 2 
            htmlAgreement += `</div>`;
            return htmlAgreement;
        }

        const agreementTime2 = charData.substr(4, 8);//  长度(byte) 4    时间
        const t1B = agreementTime2.substr(0, 2);
        const t2B = agreementTime2.substr(2, 2);
        const t3B = agreementTime2.substr(4, 2);
        const TimeB = `2020-10-10  ${formatNumber(decToHex(t1B, 10))}:${formatNumber(decToHex(t2B, 10))}:${formatNumber(decToHex(t3B, 10))}`;
        const dateB = new Date(TimeB);
        if (!isNaN(dateB.getTime())) {
            htmlAgreement += `<div>时间：${formatNumber(decToHex(t1B, 10))}:${formatNumber(decToHex(t2B, 10))}:${formatNumber(decToHex(t3B, 10))}</div>`;
            const agreement3 = charData.substr(12, 8); // 长度(byte) 4 
            const lon1 = decToHex(agreement3.substr(0, 2), 10);
            const lon2 = decToHex(agreement3.substr(2, 2), 10);
            const lon3 = decToHex(agreement3.substr(4, 2), 10);
            const lon4 = decToHex(agreement3.substr(6, 2), 10);
            const lon = accAdd(accAdd(lon1, accDiv(lon2, 60)), accDiv(`${lon3}.${formatNumber(lon4)}`, 3600));
            const agreement4 = charData.substr(20, 8); // 长度(byte) 4
            const lat1 = decToHex(agreement4.substr(0, 2), 10);
            const lat2 = decToHex(agreement4.substr(2, 2), 10);
            const lat3 = decToHex(agreement4.substr(4, 2), 10);
            const lat4 = decToHex(agreement4.substr(6, 2), 10);
            const lat = accAdd(accAdd(lat1, accDiv(lat2, 60)), accDiv(`${lat3}.${formatNumber(lat4)}`, 3600));

            htmlAgreement += `<div>经度：${formatDegree(lon, 'longitude', 2)}  </div>`;
            htmlAgreement += `<div>纬度：${formatDegree(lat, 'latitude', 2)} </div>`;

            const agreement5 = charData.substr(28, 4)// 长度(byte) 2
            const Height1 = agreement5.substr(0, 2);
            const Height2 = agreement5.substr(2, 2);// Position 长度(byte) 1 表示高度的绝对值
            htmlAgreement += `<div >高度：${agreement5 == 'FFFF' ? '-' : `${decToHex(Height1, 10) == 1 ? '-' : ''}${decToHex(Height2, 10)}`}</div>`;

            const agreement6 = charData.substr(32, 4)// 长度(byte) 2

            const Height11 = agreement6.substr(0, 2);
            const Height21 = agreement6.substr(2, 2);
            htmlAgreement += `<div>高度异常值：${agreement6 == 'FFFF' ? '-' : `${decToHex(Height11, 10) == 1 ? '-' : ''}${decToHex(Height21, 10)}`}</div>`;
            const agreement7 = charData.substr(36)// 信息
            htmlAgreement += `<div>信息：${GB18030StringZh(agreement7)}</div>`;
            htmlAgreement += `</div>`;
            return htmlAgreement;
        }


        htmlAgreement += `<div>内容识别错误，请另外尝试！！！</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement;
    }
    /**
    *@description: 处理协议  01 E1
    *@param {*} 例子  01E1 65DEDDC4   711A2D02   17091B06   0010 0020   CED2D2D1B0B2C8ABB5BDB4EF
    *@param {*} 例子  01E165DEDDC4711A2D0217091B0600020020CED2D2D1B0B2C8ABB5BDB4EF
    */
    agreementOK(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 常量,01
        const agreement01 = charData.substr(2, 2); // 长度(byte) 1  说明 常量，E1,无定位时为，经纬度为0.
        const agreement1 = charData.substr(4, 8);//  长度(byte) 4 时间戳
        const agreement2 = charData.substr(12, 20);// 长度(byte) 10  说明 用户位置，参考：Position
        const agreement3 = charData.substr(32, 4);//  长度(byte) 2 高度异常值
        const agreement4 = charData.substr(36);// 聊天信息,GB18030编码

        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：${this.agreementType[agreement0]}</div>`;
        htmlAgreement += `<div>时间：${formatDate(accMul(decToHex(agreement1, 10), 1000))}</div>`;

        const lon1 = decToHex(agreement2.substr(0, 2), 10);
        const lon2 = decToHex(agreement2.substr(2, 2), 10);
        const lon3 = decToHex(agreement2.substr(4, 2), 10);
        const lon4 = decToHex(agreement2.substr(6, 2), 10);
        const lon = accAdd(accAdd(lon1, accDiv(lon2, 60)), accDiv(`${lon3}.${formatNumber(lon4)}`, 3600));

        const lat1 = decToHex(agreement2.substr(8, 2), 10);
        const lat2 = decToHex(agreement2.substr(10, 2), 10);
        const lat3 = decToHex(agreement2.substr(12, 2), 10);
        const lat4 = decToHex(agreement2.substr(14, 2), 10);
        const lat = accAdd(accAdd(lat1, accDiv(lat2, 60)), accDiv(`${lat3}.${formatNumber(lat4)}`, 3600));
        const Height = decToHex(agreement2.substr(16, 4), 10);
        const Height1 = agreement2.substr(16, 2);// Position 长度(byte) 1 ’00’表示高度为正，01表示高度为负
        const Height2 = agreement2.substr(18, 2);// Position 长度(byte) 1 表示高度的绝对值
        htmlAgreement += `<div class="ml_20">
        经度：${formatDegree(lon, 'longitude', 2)}  
        纬度：${formatDegree(lat, 'latitude', 2)}  
        高度：${Height == 'FFFF' ? '-' : `${decToHex(Height1, 10) == 1 ? '-' : ''}${decToHex(Height2, 10)}`}
        </div>`;
        const Height11 = agreement3.substr(0, 2);// Position 长度(byte) 1 ’00’表示高度为正，01表示高度为负
        const Height21 = agreement3.substr(2, 2);// Position 长度(byte) 1 表示高度的绝对值
        htmlAgreement += `<div>高度异常值：${agreement3 == 'FFFF' ? '-' : `${decToHex(Height11, 10) == 1 ? '-' : ''}${decToHex(Height21, 10)}`}</div>`;
        htmlAgreement += `<div>信息：${GB18030StringZh(agreement4)}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement;
    }
    /**
    *@description: 处理协议  D0       
    *@param {*} 例子 65DEDDC4 8   CE D2 D2 D1 B0 B2 C8 AB B5 BD B4 EF   24 2065DEDDC4CED2D2D1B0B2C8ABB5BDB4EF      D0 1239808701 02(上报条数  2) 10(第1条数据的长度解析后是  16 )  65FA9716（时间   8） CED2CAC7（数据内容  8） 1065FA9716CED2CAC7           
    D0   1239808701   02  12    65FA9716    BEC8C3FCA3  ACC7EBBOEFD6FACED2A3A11265FAA5D6BEC8C3FCA3ACC7EBBOEFD6FACED2A3A1
    *@param {*} 例子  D00000000001022065DEDDC4CED2D2D1B0B2C8ABB5BDB4EF2065DEDDC4CED2D2D1B0B2C8ABB5BDB4EF
    */
    agreementCGQ(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 消息类型
        const agreement1 = charData.substr(2, 10);//  长度(byte) 5 说明 时间戳
        const agreement2 = charData.substr(12, 2);// 长度(byte) 1  说明 上报条数

        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：${this.agreementType[agreement0]}</div>`;
        htmlAgreement += `<div>上报警卡号：${decToHex(agreement1, 10)}</div>`;
        htmlAgreement += `<div>上报条数：${decToHex(agreement2, 10)}</div>`;

        let endIndex = 14; // (1+5+1)*2 = 14;  开始位置
        for (let index = 0; index < agreement2; index++) {
            const indexNum = endIndex;
            let lensubstr = decToHex(charData.substr(indexNum, 2), 10); //数据的长度
            let Time = charData.substr(indexNum + 2, 8); // 长度(byte) 4  说明 数据的时间 
            let dataLength = accSub(8, lensubstr);
            let gbkZh = charData.substr(indexNum + 2 + 8, dataLength); //数据内容
            endIndex = accAdd(accAdd(endIndex, lensubstr), 2);
            htmlAgreement += `<div class="ml_20">`;
            htmlAgreement += `<div>第${index + 1}条上报</div>`;
            htmlAgreement += `<div class="ml_20">时间：${formatDate(accMul(decToHex(Time, 10), 1000))}</div>`;
            htmlAgreement += `<div class="ml_20">内容：${GB18030StringZh(gbkZh)}</div>`;
            htmlAgreement += `</div>`;
        }

        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description: 处理协议   D1      
    *@param {*} 例子  D1 08 02 010065 020066 030067
    *@param {*} 例子  D10802010065020066030067
    */
    agreementD1(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 消息类型
        const agreement1 = charData.substr(2, 2);//  长度(byte) 1 说明 时间戳
        const agreement2 = charData.substr(4, 2);// 长度(byte) 1  说明 上报条数
        const bdType = { 0: '测试数据', 1: '基础数据（设备已安装）', 2: '常规监控数据', }

        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：${this.agreementType[agreement0]}</div>`;
        htmlAgreement += `<div>网关/主机编号：${decToHex(agreement1, 10)}</div>`;
        htmlAgreement += `<div>类型：${bdType[decToHex(agreement2, 10)] || ''}</div>`;

        const allLength = accSub(6, charData.length);
        const numberSy = Math.floor((accDiv(allLength, 6)));
        for (let index = 0; index < numberSy; index++) {
            const indexNum = accAdd(6, accMul(6, index));

            let TSensorType = charData.substr(indexNum, 2); // 长度(byte) 1  说明 传感器类型1
            let SensorValue = charData.substr(accAdd(indexNum, 2), 4); // 长度(byte) 2  说明 传感器值1
            let TSensorItem = this.sensorType.find(f => f.id == TSensorType) || '';

            htmlAgreement += `<div class="ml_20">`;
            htmlAgreement += `<div class="ml_20">第${index + 1}条</div>`;
            htmlAgreement += `<div class="ml_20">传感器类型：${TSensorItem?.content || ''}</div>`;
            htmlAgreement += `<div class="ml_20">传感器值：${decToHex(SensorValue, 10)} ${TSensorItem?.unit || ''}</div>`;
            htmlAgreement += `</div>`;
        }

        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:  : 处理协议 10  E4    
    *@param {*} 例子 10 E4 01   130115020803   12   711A2D02  8  17091B06 8  0008  4  0008   4     36
    *@param {*} 例子 10E402130115020803711A2D0217091B0600080008130115020803711A2D0217091B0600080008
    */
    agreementE4(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 消息类型
        const agreement1 = charData.substr(2, 2);//  长度(byte) 1  说明 指令类型
        const agreement3 = charData.substr(4, 2);// 长度(byte) 1   说明 点个数
        const locNumber = decToHex(agreement3, 10);

        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：${this.agreementType[agreement0]}</div>`;
        htmlAgreement += `<div>指令类型：${agreement1 == 'E4' ? '二代盒子的极限追踪指令' : ''}</div>`;
        htmlAgreement += `<div>点个数：${locNumber}</div>`;


        for (let index = 0; index < locNumber; index++) {
            const element = 6 + accMul(index, 36);  //
            const locItem = charData.substr(element, 36);

            const t1 = locItem.substr(0, 2);
            const t2 = locItem.substr(2, 2);
            const t3 = locItem.substr(4, 2);

            const t4 = locItem.substr(6, 2);
            const t5 = locItem.substr(8, 2);
            const t6 = locItem.substr(10, 2);
            const Time = `20${formatNumber(decToHex(t1, 10))}-${formatNumber(decToHex(t2, 10))}-${formatNumber(decToHex(t3, 10))}  ${formatNumber(decToHex(t4, 10))}:${formatNumber(decToHex(t5, 10))}:${formatNumber(decToHex(t6, 10))}`;

            const lon1 = decToHex(locItem.substr(12, 2), 10);
            const lon2 = decToHex(locItem.substr(14, 2), 10);
            const lon3 = decToHex(locItem.substr(16, 2), 10);
            const lon4 = decToHex(locItem.substr(18, 2), 10);
            const lon = accAdd(accAdd(lon1, accDiv(lon2, 60)), accDiv(`${lon3}.${formatNumber(lon4)}`, 3600));

            const lat1 = decToHex(locItem.substr(20, 2), 10);
            const lat2 = decToHex(locItem.substr(22, 2), 10);
            const lat3 = decToHex(locItem.substr(24, 2), 10);
            const lat4 = decToHex(locItem.substr(26, 2), 10);
            const lat = accAdd(accAdd(lat1, accDiv(lat2, 60)), accDiv(`${lat3}.${formatNumber(lat4)}`, 3600));

            const Height = decToHex(locItem.substr(28, 4), 10);
            const Height1 = locItem.substr(28, 2);// Position 长度(byte) 1 ’00’表示高度为正，01表示高度为负
            const Height2 = locItem.substr(30, 2);// Position 长度(byte) 1 表示高度的绝对值
            htmlAgreement += `<div class="ml_20">
            时间：${Time}  
            经度：${formatDegree(lon, 'longitude', 2)}  
            纬度：${formatDegree(lat, 'latitude', 2)}  
            高度：${Height == 'FFFF' ? '-' : `${decToHex(Height1, 10) == 1 ? '-' : ''}${decToHex(Height2, 10)}`}
            轨迹序号：${decToHex(locItem.substr(32, 4), 10)}
            </div>`;
        }
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description: 处理 00  EE A4
    *@param {*} 
    *@Date :  2024-03-27 10:25:28
    */
    agreement00(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 常量,01
        const agreement01 = charData.substr(2, 2);
        let htmlCommunication2 = ``;
        switch (agreement01) {
            case "EE":
                htmlCommunication2 = this.agreementEE(charData);
                break;
            case "A4":
                htmlCommunication2 = this.agreementA4(charData);
                break;
            default:
                alert("数据错误或未获取该协议");
                break;
        }
        return htmlCommunication2;
    }
    /**
    *@description:  : 处理协议 00  EE   
    *@param {*} 例子  00 EE 65DEDDC4  711E0008 17091202  0005 0001
    *@param {*} 例子  00EE65DEDDC4711E00081709120200050001
    */
    agreementEE(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 消息类型
        const agreement1 = charData.substr(2, 2);//  长度(byte) 1  说明 指令类型
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：SOS</div>`
        if (charData.length == 10) {
            htmlAgreement += `<div>指令类型：一代盒子的SOS</div>`;
            htmlAgreement += `</div>`;
            return htmlAgreement
        }
        const agreement2 = charData.substr(4, 8);//  长度(byte) 4    时间
        const t1 = agreement2.substr(0, 2);
        const t2 = agreement2.substr(2, 2);
        const t3 = agreement2.substr(4, 2);
        const Time = `2020-10-10  ${formatNumber(decToHex(t1, 10))}:${formatNumber(decToHex(t2, 10))}:${formatNumber(decToHex(t3, 10))}`;
        const date = new Date(Time);
        if (!isNaN(date.getTime())) {
            htmlAgreement += `<div>指令类型：二代盒子的SOS</div>`;
            const agreement3 = charData.substr(12, 8);//  长度(byte) 4   经度 
            const agreement4 = charData.substr(20, 8);//  长度(byte) 4   纬度
            const agreement5 = charData.substr(28, 4);  //  长度(byte) 2   高度
            const agreement6 = charData.substr(32, 4);  //  长度(byte) 2   高度异常值 
            const Height1 = agreement5.substr(0, 2);// Position 长度(byte) 1 ’00’表示高度为正，01表示高度为负
            const Height2 = agreement5.substr(2, 4);// Position 长度(byte) 1 表示高度的绝对值
            const dtHeight1 = agreement6.substr(0, 2);// Position 长度(byte) 1 ’00’表示高度为正，01表示高度为负
            const dtHeight2 = agreement6.substr(2, 4);// Position 长度(byte) 1 表示高度的绝对值
            // const t1 = agreement3.substr(0, 2);
            // const t2 = agreement3.substr(2, 2);
            // const t3 = agreement3.substr(4, 2);
            // const Time = `${formatNumber(decToHex(t4, 10))}:${formatNumber(decToHex(t5, 10))}:${formatNumber(decToHex(t6, 10))}`;
            const lon1 = decToHex(agreement3.substr(0, 2), 10);
            const lon2 = decToHex(agreement3.substr(2, 2), 10);
            const lon3 = decToHex(agreement3.substr(4, 2), 10);
            const lon4 = decToHex(agreement3.substr(6, 2), 10);
            const lon = accAdd(accAdd(lon1, accDiv(lon2, 60)), accDiv(`${lon3}.${formatNumber(lon4)}`, 3600));

            const lat1 = decToHex(agreement4.substr(0, 2), 10);
            const lat2 = decToHex(agreement4.substr(2, 2), 10);
            const lat3 = decToHex(agreement4.substr(4, 2), 10);
            const lat4 = decToHex(agreement4.substr(6, 2), 10);
            const lat = accAdd(accAdd(lat1, accDiv(lat2, 60)), accDiv(`${lat3}.${formatNumber(lat4)}`, 3600));
            htmlAgreement += `<div>时间：${formatNumber(decToHex(t1, 10))}:${formatNumber(decToHex(t2, 10))}:${formatNumber(decToHex(t3, 10))}</div>`;
            htmlAgreement += `<div>经度：${formatDegree(lon, 'longitude', 2)} </div>`;
            htmlAgreement += `<div>纬度：${formatDegree(lat, 'latitude', 2)} </div>`;
            htmlAgreement += `<div>高度：${agreement5 == 'FFFF' ? '-' : `${decToHex(Height1, 10) == 1 ? '-' : ''}${decToHex(Height2, 10)}`} </div>`;
            htmlAgreement += `<div>高度异常值：${agreement6 == 'FFFF' ? '-' : `${decToHex(dtHeight1, 10) == 1 ? '-' : ''}${decToHex(dtHeight2, 10)}`} </div>`;
            htmlAgreement += `</div>`;
            return htmlAgreement
        }
        htmlAgreement += `<div>数据操作错误！！！</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:  : 处理协议 00  A4   
    *@param {*} 例子  00A4 18030D081F24 0050 02 45 711E0008 4E 17091202   0000000001 45711E01014E170912020000000001DB
    *@param {*} 例子  00A418030D081F2400500245711E00084E17091202000000000145711E01014E170912020000000001DB
    */
    agreementA4(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 消息类型
        const agreement1 = charData.substr(2, 2);//  长度(byte) 1  说明 指令类型
        const locItem = charData.substr(4, 12);//  长度(byte) 6  说明 12位ASCII码,16进制字符串: (最后一个采集点的时间) 
        const agreement3 = charData.substr(16, 4);// 长度(byte) 2   说明  4位ASCII码,16进制字符串: 单位(S)
        const agreement4 = charData.substr(20, 2); // 长度(byte) 1  说明 HEX	2位ASCII码,16进制字符串


        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：${this.agreementType[agreement0]}</div>`

        const t1 = locItem.substr(0, 2);
        const t2 = locItem.substr(2, 2);
        const t3 = locItem.substr(4, 2);
        const t4 = locItem.substr(6, 2);
        const t5 = locItem.substr(8, 2);
        const t6 = locItem.substr(10, 2);
        const Time = `20${formatNumber(decToHex(t1, 10))}-${formatNumber(decToHex(t2, 10))}-${formatNumber(decToHex(t3, 10))}  ${formatNumber(decToHex(t4, 10))}:${formatNumber(decToHex(t5, 10))}:${formatNumber(decToHex(t6, 10))}`;

        htmlAgreement += `<div>时间：${Time}</div>`;
        htmlAgreement += `<div>采样频度：${decToHex(agreement3, 10)}</div>`;
        htmlAgreement += `<div>信息个数：${decToHex(agreement4, 10)}</div>`;

        const agreement5 = charData.substr(22, 10);
        const LongFx = agreement5.substr(0, 2);
        const Longitude = agreement5.substr(2, 8);

        const lon1 = decToHex(Longitude.substr(0, 2), 10);
        const lon2 = decToHex(Longitude.substr(2, 2), 10);
        const lon3 = decToHex(Longitude.substr(4, 2), 10);
        const lon4 = decToHex(Longitude.substr(6, 2), 10);
        const lon = accAdd(accAdd(lon1, accDiv(lon2, 60)), accDiv(`${lon3}.${formatNumber(lon4)}`, 3600));

        htmlAgreement += `<div>经度：${formatDegree2(lon, 2)} ${LongFx == '57' ? 'W' : 'E'}</div>`;

        const agreement6 = charData.substr(32, 10);
        const LatFx = agreement6.substr(0, 2);
        const Latitude = agreement6.substr(2, 8);

        const lat1 = decToHex(Latitude.substr(0, 2), 10);
        const lat2 = decToHex(Latitude.substr(2, 2), 10);
        const lat3 = decToHex(Latitude.substr(4, 2), 10);
        const lat4 = decToHex(Latitude.substr(6, 2), 10);
        const lat = accAdd(accAdd(lat1, accDiv(lat2, 60)), accDiv(`${lat3}.${formatNumber(lat4)}`, 3600));
        htmlAgreement += `<div>纬度：${formatDegree2(lat, 2)} ${LatFx == '53' ? 'S' : 'N'}</div>`;

        const agreement7 = charData.substr(42, 4);
        const agreement8 = charData.substr(46, 4);
        const agreement9 = charData.substr(50, 2);
        htmlAgreement += `<div>速度：${decToHex(agreement7, 10)}</div>`;
        htmlAgreement += `<div>方向：${decToHex(agreement8, 10)}</div>`;
        htmlAgreement += `<div>状态：${agreement9 == '00' ? '未定位' : "定位"}</div>`;

        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:  : 处理协议 E0
    *@param {*} 例子 E0  0000000000  00000000000000000010
    *@param {*} 例子  E0000000000000000000000000000010
    */
    agreementE0(charData) {
        const agreement0 = charData.substr(0, 2); // 长度(byte) 1  说明 消息类型
        const agreement1 = charData.substr(2, 10);//  长度(byte) 5  说明 指令类型
        const agreement2 = charData.substr(12, 20); // 长度(byte) 10  说明 HEX	2位ASCII码,16进制字符串

        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div>消息类型：${this.agreementType[agreement0]}</div>`
        htmlAgreement += `<div>天通ID：${decToHex(agreement2, 10)}</div>`;

        htmlAgreement += `</div>`;
        return htmlAgreement
    }

}
const tdwtProxyg = new tdwtClass();
export default tdwtProxyg;
//   module.exports = new tdwtClass();
